<!-- eslint-disable max-lines -->
<template>
  <div class="base-form">
    <div class="form-title"><Title text="基本信息" /></div>
    <div class="step-ctn">
      <AddAderStep
        :stage="stage"
        :steps="steps"
      />
    </div>
    <el-form
      v-if="stage === 1"
      ref="formAdv"
      :model="formAdv"
      :rules="rulesAdv"
      label-width="123px"
      class="form-box"
    >
      <el-form-item
        class="u-crm-form-item"
        label="广告主公司名称"
        prop="company"
      >
        <el-autocomplete
          v-model="formAdv.company"
          :fetch-suggestions="querySearchComany"
          placeholder="请输入广告公司名称，最多256个字"
          style="width: 100%"
          @select="handleCompanySelect"
        >
          <template slot-scope="{ item }">
            {{ item.company || '' }}
          </template>
        </el-autocomplete>
        <div
          v-if="!isCreateAdv"
          class="adv-tip"
        >
          客户存在，可导入
        </div>
      </el-form-item>
      <el-form-item
        class="u-crm-form-item"
        label="品牌"
        prop="brand"
      >
        <el-select
          v-model="formAdv.brand"
          :disabled="brandDisableSelect"
          filterable
          placeholder="请选择品牌"
          style="width: 100%"
          @change="handleBrandChange"
        >
          <el-option
            v-for="item in brands"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-tooltip
          effect="light"
          placement="top"
          content="没有找到品牌，请选择其他"
        >
          <img
            class="form-tip-icon"
            :src="iconTip"
          >
        </el-tooltip>
      </el-form-item>

      <el-form-item class="btn-form-item">
        <div class="btn-ctn">
          <el-button
            class="form-btn"
            type="primary"
            :loading="submitLoading"
            @click="submitFormAction('formAdv')"
          >
            {{ isCreateAdv ? '创建客户，并下一步' : '导入客户，并下一步' }}
          </el-button>
        </div>
      </el-form-item>
    </el-form>

    <el-form
      v-else-if="stage === 2"
      ref="formProduct"
      :model="formProduct"
      :rules="rulesProduct"
      label-width="123px"
      class="form-box"
    >
      <el-form-item
        label="广告主公司名称"
        prop="company"
        style="margin-bottom: 8px;"
      >
        <div>{{ formAdv.company }}</div>
      </el-form-item>
      <el-form-item
        label="品牌"
        prop="brand"
        style="margin-bottom: 20px;"
      >
        <div>{{ brandName }}</div>
      </el-form-item>
      <el-form-item
        label="合作产品"
        prop="product"
        class="product-form-section"
      >
        <el-select
          ref="productSelect"
          v-model="formProduct.product"
          multiple
          filterable
          remote
          :remote-method="_fetchProduct"
          placeholder="请选择合作产品"
          style="width: 100%"
        >
          <el-option
            v-for="item in products"
            :key="item.product_id"
            :label="item.product_name"
            :value="item.product_id"
            :disabled="checkBind(item)"
          >
            <template>
              <el-tooltip
                v-if="checkBind(item)"
                effect="dark"
                :content="disableTip(item)"
                placement="top"
              >
                <span>{{ item.product_name }}</span>
              </el-tooltip>
              <div v-else>
                <span>{{ item.product_name }}</span>
              </div>
            </template>
          </el-option>
        </el-select>
        <el-tooltip
          effect="light"
          placement="top"
          content="没有找到产品，请联系运营添加"
        >
          <img
            class="form-tip-icon"
            :src="iconTip"
          >
        </el-tooltip>
      </el-form-item>

      <el-form-item class="btn-form-item">
        <div class="btn-ctn">
          <el-button
            class="form-btn"
            type="primary"
            plain
            @click="prev"
          >
            上一步
          </el-button>
          <el-button
            class="form-btn"
            type="primary"
            :loading="submitLoading"
            @click="submitFormAction('formProduct')"
          >
            绑定产品
          </el-button>
        </div>
      </el-form-item>
    </el-form>

    <div
      v-else-if="stage === 3"
      ref="formResult"
      class="form-result"
    >
      <div class="result-icon">
        <img :src="iconSucc">
      </div>
      <div class="result-title">提交成功</div>
      <div class="result-desc">恭喜您，广告主和产品已经添加成功</div>
      <el-form
        label-width="123px"
        class="gray-form"
      >
        <el-form-item
          class="gray-form-item"
          label="广告主公司名称"
          prop="company"
        >
          <div class="r">{{ formAdv.company }}</div>
          <!-- <div class="r">formAdv.company</div> -->
        </el-form-item>
        <el-form-item
          class="gray-form-item"
          label="品牌"
          prop="brand"
        >
          <div class="r">{{ brandName }}</div>
          <!-- <div class="r">formAdv.brandName</div> -->
        </el-form-item>
        <el-form-item
          class="gray-form-item"
          label="合作产品"
          prop="brand"
        >
          <div class="r">{{ productToBind }}</div>
        </el-form-item>
      </el-form>
      <div class="result-btn">
        <el-button
          type="primary"
          @click="toList"
        >
          返回列表
        </el-button> &nbsp;
        <el-button
          type="primary"
          plain
          @click="back"
        >
          继续添加
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import QuRequest from '@/core/QuRequest';
import Title from '@/components/Title';
import AddAderStep from './components/AddAderStep';
import IconTip from '@/assets/image/icon/tip-icon.png';
import IconSucc from '@/assets/image/icon/success-icon_140_140.png';

const request = new QuRequest();

const AddAderSteps = [
  { id: '1', name: '创建客户' },
  { id: '2', name: '绑定产品' },
  { id: '3', name: '提交成功' },
];
const ImportAderSteps = [
  { id: '1', name: '导入客户' },
  { id: '2', name: '绑定产品' },
  { id: '3', name: '提交成功' },
];

export default {
  name: 'AdvertiserManagePrivateAddAder',
  components: { Title, AddAderStep },
  data() {
    return {
      iconSucc: IconSucc,
      stage: 1, // 当前填写表单步骤，1为添加广告主 2为绑定产品 3为结果
      brandDisableSelect: false,
      isCreateAdv: true, // 默认true创建客户，false为导入客户
      inputMatchedItem: {}, // 导入客户时记下的客户信息
      products: [],
      iconTip: IconTip,
      submitLoading: false,
      companyTimer: null,
      companies: [],
      form: {},
      brands: [],
      brandName: '',
      customerId: '',
      formAdv: {
        company: '',
        brand: '',
      },
      formProduct: {
        product: [],
      },
      rulesAdv: {
        company: [
          {
            required: true,
            message: '广告主公司名称必填',
            type: 'string',
            triggle: 'blur',
          },
          { min: 1, max: 256, message: `长度为1-256`, triggle: 'blur' },
          {
            pattern: /^[\u4e00-\u9fffa-zA-Z\d\s|\\(|\\)|\\（|\\）]+$/,
            message: '只能包含汉字、英文字母、数字、中英文括号、英文单词等',
            triggle: 'blur',
          },
        ],
        brand: [
          {
            required: true,
            message: '品牌名必填',
            type: 'string',
            triggle: 'change',
          },
        ],
      },
      rulesProduct: {
        product: [
          {
            required: true,
            type: 'array',
            message: '产品必填',
            triggle: 'change',
          },
        ],
      },
    };
  },

  computed: {
    steps() {
      return this.isCreateAdv ? AddAderSteps : ImportAderSteps;
    },

    productToBind() {
      let nameArr = [];
      let selectedProduct = this.formProduct.product || [];
      // eslint-disable-next-line array-callback-return
      (this.products || []).filter((item) => {
        if (selectedProduct.indexOf(item.product_id) > -1) {
          nameArr.push(item.product_name);
        }
      });
      return nameArr.join(',');
    },
  },

  created() {
    this._fetchProduct();
    this._fetchBrand();
  },

  methods: {
    checkBind(productItem = {}) {
      // is_bind：产品是否被绑定 0否, 1 2 3等表示是
      if (productItem.is_bind && productItem.is_bind !== '0') {
        return true;
      } else {
        return false;
      }
    },

    async _fetchProduct(key) {
      try {
        const params = {
          name: key || '',
          page_size: 50,
          status: 0,
        };
        const res = await request.send(
          request.Apis.sales.customerStage2.productOwner,
          params,
        );
        let resData = [...(res.data || [])];
        this.products = this.addOptions(this.products, resData);
        this.optionScrollToTop();
      } catch (err) {
        console.error(`获取产品失败：${err.message || '未知错误'}`);
      }
    },

    // 累加
    addOptions(oldOptions = [], freshOptions = []) {
      let allOptions = [...freshOptions, ...oldOptions];
      let uniqueOptions = [];
      let temp = [];
      for (let i = 0; i < allOptions.length; i++) {
        if (temp.indexOf(allOptions[i].product_id) === -1) {
          temp.push(allOptions[i].product_id);
          uniqueOptions.push(allOptions[i]);
        }
      }
      return uniqueOptions;
    },

    optionScrollToTop() {
      if (this.$refs.productSelect) {
        this.$refs.productSelect.popperElm.querySelector(
          '.el-scrollbar__wrap',
        ).scrollTop = 0;
      }
    },

    disableTip(item = {}) {
      let tip = '不可绑定';
      if (item.is_bind && item.is_bind !== '0') {
        if (item.customer_id === this.customerId) {
          tip = '此产品已经被此客户绑定，可以去【归属查询】页面查询归属';
        } else {
          tip = `此产品已经被【${item.company}】绑定，可以去【归属查询】页面查询归属`;
        }
      }
      return tip;
    },

    // 获取品牌
    async _fetchBrand() {
      try {
        const params = {
          type: '2',
        };
        const res = await request.send(
          request.Apis.sales.common.config,
          params,
        );
        if (res.code === 200) {
          this.brands = [...res.data];
        }
      } catch (err) {
        console.error(`获取品牌失败：${err.message || '未知错误'}`);
      }
    },

    resetAdvForm() {
      this.isCreateAdv = true;
      this.brandDisableSelect = false;
      this.inputMatchedItem = {};
      this.customerId = '';
      this.formAdv = {
        company: '',
        brand: '',
      };
    },

    async querySearchComany(key, cb) {
      if (!key) {
        // reset
        this.resetAdvForm();
        const arr = [];
        cb(arr);
        return false;
      }

      this.formAdv.company = key;

      if (this.companyTimer) {
        clearTimeout(this.companyTimer);
      }

      let list = (await this._fetchCompany(key)) || [];
      if (list.length === 0) {
        // 没有返回客户列表，肯定新建客户
        this.isCreateAdv = true;
        this.brandDisableSelect = false;
      } else {
        let listCompanyName = list.map((i) => i.company);
        // 输入框公司名称不在返回的列表中, 是新建客户
        if (listCompanyName.indexOf(key) === -1) {
          this.isCreateAdv = true;
          this.brandDisableSelect = false;
        } else {
          // 输入框公司名称在返回的列表中,为导入客户(导入时需要设置customerId)
          this.isCreateAdv = false;
          this.inputMatchedItem = list.find((i) => i.company === key);
          this.customerId = this.inputMatchedItem.id;
          this.setBrandStatus(this.inputMatchedItem);
        }
      }
      this.companyTimer = setTimeout(() => {
        cb(list);
      }, 100);
    },

    async _fetchCompany(key = '') {
      try {
        // if (!key) return [];
        const params = {
          company: key || '',
        };
        const res = await request.send(
          request.Apis.sales.customerStage2.company,
          params,
        );
        if (res.code === 200) {
          this.companies = [...(res.data || [])];
          if (res.data && res.data.length > 0) {
            return res.data;
          } else {
            return [];
          }
        }
      } catch (err) {
        console.error(`获取公司信息失败：${err.message || '未知错误'}`);
      }
    },

    // 选择广告主公司名称, selectedObj为选中公司信息
    handleCompanySelect(selectedObj) {
      this.isCreateAdv = false;
      this.inputMatchedItem = selectedObj;
      this.customerId = selectedObj.id; // 设置选中的客户id
      this.setBrandStatus(selectedObj);

      this.$nextTick(() => {
        this.formAdv.company = selectedObj.company;
      });
    },

    // 设置品牌是否可选
    setBrandStatus(adv) {
      if (adv.brand !== '0') {
        // 有品牌自动带出，不能选择
        this.formAdv.brand = adv.brand;
        this.brandName = this.brands.find((i) => i.id === adv.brand).name || '';
        this.brandDisableSelect = true;
      } else {
        // brand === 0, 没有品牌，可以选择
        this.brandDisableSelect = false;
      }
    },

    // 选择品牌
    handleBrandChange(val) {
      this.formAdv.brand = val;
      this.brandName = this.brands.find((i) => i.id === val).name || '';
    },

    // 调用添加广告主接口
    // params: company  brand_id（品牌id必须不能为汉字，TODO检查出现汉字处理为''或者转为对应id型）
    async processCreateAdv() {
      try {
        this.submitLoading = true;
        const res = await request
          .send(request.Apis.sales.customerStage2.create, {
            company: this.formAdv.company || '',
            brand_id: this.formAdv.brand || '',
          })
          .fin(() => {
            this.submitLoading = false;
          });
        if (res.code === 200) {
          this.customerId = res.data.customer_id;
          this.stage = 2;
        }
      } catch (err) {
        this.$message({
          message: `添加广告主失败：${err.message || '未知错误'}`,
          type: 'error',
          duration: 4000,
        });
      }
    },

    async processUpBrand() {
      try {
        this.submitLoading = true;
        const res = await request
          .send(request.Apis.sales.customerStage2.upBrand, {
            customer_id: this.customerId || '',
            brand_id: this.formAdv.brand || '',
          })
          .fin(() => {
            this.submitLoading = false;
          });
        if (res.code === 200) {
          this.stage = 2;
        }
      } catch (err) {
        this.$message({
          message: `修改品牌失败：${err.message || '未知错误'}`,
          type: 'error',
          duration: 4000,
        });
      }
    },

    // 调用绑定产品的接口
    // params: customer_id  product_ids
    async processProductSubmit() {
      try {
        this.submitLoading = true;
        await request
          .send(request.Apis.sales.customerStage2.bindProduct, {
            customer_id: this.customerId || '',
            product_ids: this.formProduct.product.join(',') || '',
          })
          .fin(() => {
            this.submitLoading = false;
          });
        this.stage = 3;
      } catch (err) {
        this.$message({
          message: `绑定产品失败：${err.message || '未知错误'}`,
          type: 'error',
          duration: 4000,
        });
      }
    },

    // 第二步骤，上一步按钮
    prev() {
      this.stage = 1;
    },

    // 提交
    submitFormAction(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (form === 'formAdv') {
            if (this.isCreateAdv) {
              // 创建客户
              this.processCreateAdv();
            } else if (!this.brandDisableSelect) {
              // 导入客户，没有品牌，先修改品牌
              this.processUpBrand();
            } else {
              // 导入客户，有品牌，直接下一步
              this.stage = 2;
            }
          } else if (form === 'formProduct') {
            if (this.formProduct.product.length === 0) {
              this.$message({
                message: `请先选择产品`,
                type: 'warning',
                duration: 1000,
              });
              return false;
            }
            this.processProductSubmit();
          }
        } else {
          return false;
        }
      });
    },

    toList() {
      this.$router.replace({ name: 'AdvertiserManagePrivateList' });
    },

    back() {
      this.reset();
    },

    reset() {
      this.stage = 1;
      this.brandDisableSelect = false;
      this.isCreateAdv = true;
      this.inputMatchedItem = {};
      this.products = [];
      this.submitLoading = false;
      this.companyTimer = null;
      this.companies = [];
      this.form = {};
      // this.brands = [];
      this.brandName = '';
      this.customerId = '';
      this.formAdv = {
        company: '',
        brand: '',
      };
      this.formProduct = {
        product: [],
      };
    },
  },
};
</script>

<style lang="less" scoped>
.base-form {
  .form-title {
    padding: 20px 0 24px 0;
  }
  .step-ctn {
    margin: 0 auto;
    margin-bottom: 40px;
    width: 350px;
  }
  .u-crm-form-item {
    margin-bottom: 32px;
  }
  .adv-tip {
    position: absolute;
    top: 34px;
    font-size: 14px;
    color: #4cd34b;
  }
  .form-box {
    margin: 0 auto;
    width: 600px;
    .form-tip-icon {
      position: absolute;
      top: 11px;
      right: -32px;
      z-index: 2;
      width: 16px;
    }
    .btn-ctn {
      margin-top: 26px;
      text-align: center;
    }
    .form-btn {
      min-width: 132px;
      margin-right: 32px;
    }
  }
  .btn-form-item {
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .form-result {
    text-align: center;
    .result-icon {
      img {
        width: 72px;
      }
    }
    .result-title {
      font-size: 24px;
      padding: 24px 0;
      color: #373c40;
    }
    .result-desc {
      font-size: 14px;
      color: #606266;
      margin-bottom: 24px;
    }
    .gray-form {
      margin: 0 auto;
      margin-bottom: 40px;
      padding-top: 16px;
      padding-bottom: 16px;
      width: 422px;
      border-radius: 4px;
      background: #f5f7fa;
      .gray-form-item {
        /deep/ .el-form-item__label {
          line-height: 20px;
          color: #303133;
          margin-left: 52px;
        }
        /deep/ .el-form-item__content {
          line-height: 20px;
          color: #303133;
          margin-left: 192px !important;
        }

        margin-bottom: 23px;
        &:last-child {
          margin-bottom: 0;
        }
        .r {
          text-align: left;
        }
      }
    }
  }
  .product-form-section {
    /deep/ .el-select .el-tag {
      background-color: #f2f9ff;
    }
    /deep/ .el-select__tags-text {
      color: #2f9eff;
    }
    /deep/ .el-select .el-tag__close.el-icon-close {
      background-color: #b2dbff;
    }
  }
}
</style>
